import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface CollapsibleDressesFilterProps {
  collection: { handle: string; title: string; id: string };
  selectedCategory: string | undefined;
  selectedDressesSubCategories: string[];
  showDressesSubCategories: boolean;
  onCategoryChange: (handle: string) => void;
  onSubCategoryChange: (subCategories: string[]) => void;
  onToggleExpansion: (expanded: boolean) => void;
  onPageChange: (page: number) => void;
}

const CollapsibleDressesFilter: React.FC<CollapsibleDressesFilterProps> = ({
  collection,
  selectedCategory,
  selectedDressesSubCategories,
  showDressesSubCategories,
  onCategoryChange,
  onSubCategoryChange,
  onToggleExpansion,
  onPageChange,
}) => {
  const dressesSubCategories = [
    'Maxi Dresses',
    'Midi Dresses',
    'Mini Dresses'
  ];

  const dressesSubCategoryLabels = [
    'Maxi',
    'Midi', 
    'Mini'
  ];

  const handleSubCategoryToggle = (subCategory: string, checked: boolean) => {
    if (checked) {
      const newSubCategories = [...selectedDressesSubCategories, subCategory];
      onSubCategoryChange(newSubCategories);
    } else {
      const newSubCategories = selectedDressesSubCategories.filter(cat => cat !== subCategory);
      onSubCategoryChange(newSubCategories);
    }
  };

  return (
    <div>
      <Collapsible open={showDressesSubCategories} onOpenChange={onToggleExpansion}>
        <CollapsibleTrigger asChild>
          <label htmlFor={`radio-${collection.handle}`} className="flex items-center space-x-2 cursor-pointer">
            <input
              id={`radio-${collection.handle}`}
              type="radio"
              name="collection"
              checked={selectedCategory === collection.handle}
              onChange={() => {
                onCategoryChange(collection.handle);
                onPageChange(1);
                onToggleExpansion(true);
              }}
              className="w-4 h-4 accent-primary bg-background border-border focus:ring-primary focus:ring-2"
            />
            <span className="text-sm text-muted-foreground/50">{collection.title}</span>
            <ChevronDown 
              className={`w-3 h-3 transition-transform ${showDressesSubCategories ? 'rotate-180' : ''}`} 
            />
          </label>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="ml-6 mt-2 space-y-1">
            {dressesSubCategories.map((subCategory, index) => (
              <label key={subCategory} htmlFor={`checkbox-dresses-${subCategory.replace(/\s+/g, '-').toLowerCase()}`} className="flex items-center space-x-2 cursor-pointer">
                <input
                  id={`checkbox-dresses-${subCategory.replace(/\s+/g, '-').toLowerCase()}`}
                  type="checkbox"
                  checked={selectedDressesSubCategories.includes(subCategory)}
                  onChange={(e) => handleSubCategoryToggle(subCategory, e.target.checked)}
                  className="w-3 h-3 accent-primary bg-background border-border focus:ring-primary focus:ring-1 rounded"
                />
                <span className="text-xs text-muted-foreground">{dressesSubCategoryLabels[index]}</span>
              </label>
            ))}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default CollapsibleDressesFilter;